export default {
    FISRT_TOOLTIP: "Add Convertible Loan Notes, SAFEs and any other related documents here.",
    TOOLTIP: 'Can\'t decide between a Convertible Loan Note or a SAFE? <a href="https://academy.clara.co/article/2IdAE0vmc1ybHtCXPeZsHj" target="_blank" >Read the guide.</a>'
}